import { Component} from '@angular/core';
import { MainLayoutComponent } from '../../_layouts/main-layout/main-layout.component';
import {
  ReactiveFormsModule,
  FormGroup,
  FormControl,
  Validators,
  AbstractControl,
  FormBuilder,
  FormsModule,
} from '@angular/forms';
import { AppSettingsService } from '../../_services/app-settings.service';
import { MatButtonModule } from '@angular/material/button';
import { AlertService } from '../../_services/alert.service';
import { MatTabsModule } from '@angular/material/tabs';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
  CdkDrag,
  CdkDropList,
} from '@angular/cdk/drag-drop';
import { CategoryService } from '../../_services/category.service';


@Component({
    selector: 'app-settings',
    imports: [MainLayoutComponent, ReactiveFormsModule, MatButtonModule, MatTabsModule, CdkDropList, CdkDrag, FormsModule],
    templateUrl: './settings.component.html',
    styleUrl: './settings.component.css'
})
export class SettingsComponent {

  companySettings: any;

  companySettingsForm: FormGroup = new FormGroup({
    companyName: new FormControl(''),
    companyAddress: new FormControl(''),
    gstNo: new FormControl(''),
    currency: new FormControl(''),
    lastOrdNo: new FormControl(''),
    companyCode: new FormControl(''),
    emailEnable:  new FormControl(''),
    adminEmails: new FormControl(''),
    supportEmail: new FormControl(''),
    salesEmail: new FormControl(''),
    affiliateEmail: new FormControl(''),
    prodSubscribeEmail: new FormControl(''),
    lowStockAlertEmail: new FormControl(''),
    outOfStockEmail: new FormControl(''),
  });
  categories: any[] = []

  unselPavCategories: any[] = []
  pavingCats: any[]  = [];

  unselHomeCategories: any[] = []
  homeCats: any[]  = [];

  constructor(
    private formBuilder: FormBuilder,
    private appSettingsService: AppSettingsService,
    private categoryService: CategoryService,
    private alertService: AlertService
  ) {}

  get f(): { [key: string]: AbstractControl } {
    return this.companySettingsForm.controls;
  }


  async onSubmit(){

    const formData = this.companySettingsForm.value;

    const inputParams: any = {
      id: this.companySettings.id,
      companyName: formData.companyName,
      companyAddress: formData.companyAddress ,
      gstNo: formData.gstNo,
      currency: formData.currency,
      lastOrdNo: formData.lastOrdNo,
      companyCode: formData.companyCode,
      emailEnable: formData.emailEnable,
      adminEmails: formData.adminEmails,
      supportEmail: formData.supportEmail,
      salesEmail: formData.salesEmail,
      affiliateEmail: formData.affiliateEmail,
      prodSubscribeEmail: formData.prodSubscribeEmail,
      lowStockAlertEmail: formData.lowStockAlertEmail,
      outOfStockEmail: formData.outOfStockEmail,
    };

    await this.appSettingsService
      .updateCompanySettings(inputParams)
      .subscribe({
        next: (response) => {
          this.alertService.alert("Company settings updated successfully!", 'success');
        },
        error: (error) => {
          this.alertService.alert(error.error.message, 'error');
        },
      });

  }

  ngOnInit(): void {
    this.companySettingsForm = this.formBuilder.group({
      companyName: new FormControl('', [Validators.required]),
      companyAddress: new FormControl('', [Validators.required]),
      gstNo: new FormControl('', [Validators.required]),
      currency: new FormControl('', [Validators.required]),
      lastOrdNo:  new FormControl('', [Validators.required]),
      companyCode:  new FormControl('', [Validators.required]),
      emailEnable: new FormControl('', [Validators.required]),
      adminEmails:  new FormControl('', [Validators.required]),
      supportEmail:  new FormControl('', [Validators.required]),
      salesEmail:  new FormControl('', [Validators.required]),
      affiliateEmail:  new FormControl('', [Validators.required]),
      prodSubscribeEmail:  new FormControl('', [Validators.required]),
      lowStockAlertEmail:  new FormControl('', [Validators.required]),
      outOfStockEmail:  new FormControl('', [Validators.required]),
    });

    this.loadCategories();
  }

  private async getAppSettings() {
    await this.appSettingsService
      .getCompanySettings()
      .subscribe({
        next: (response) => {
         if (response) {
          this.companySettings = response;
          const pavingCats = this.companySettings.pavingMenu.split(',');
          pavingCats.map((p : any)=> {
            const cat = this.categories.filter(c => c.id == Number(p));
            if(cat && cat.length > 0)
              this.pavingCats.push(cat[0]);
          });
          this.unselPavCategories = this.categories.filter(c => pavingCats.indexOf(c.id.toString()) < 0);

          const homeCats = this.companySettings.categoryMenu.split(',');
          homeCats.map((p : any)=> {
            const cat = this.categories.filter(c => c.id == Number(p));
            if(cat && cat.length > 0)
              this.homeCats.push(cat[0]);
          });
          this.unselHomeCategories = this.categories.filter(c => homeCats.indexOf(c.id.toString()) < 0);

          this.companySettingsForm.setValue({
            companyName: this.companySettings.companyName,
            companyAddress: this.companySettings.companyAddress,
            gstNo: this.companySettings.gstNo,
            currency: this.companySettings.currency,
            lastOrdNo: this.companySettings.lastOrdNo,
            companyCode: this.companySettings.companyCode,
            emailEnable: this.companySettings.emailEnable,
            adminEmails: this.companySettings.adminEmails,
            supportEmail: this.companySettings.supportEmail,
            salesEmail: this.companySettings.salesEmail,
            affiliateEmail: this.companySettings.affiliateEmail,
            prodSubscribeEmail: this.companySettings.prodSubscribeEmail,
            lowStockAlertEmail: this.companySettings.lowStockAlertEmail,
            outOfStockEmail: this.companySettings.outOfStockEmail,
          });
         }
        },
        error: (error) => {
          console.log(error);
        },
      });
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

  

  private async loadCategories() {
    await this.categoryService.getAllCategories().subscribe({
      next: (response: any) => {
        let categories = response;

        let cats: any = [];

        categories.map((cat: any) => {
          cat.subCategories?.map((subcat: any) => {
            this.categories.push( {name: subcat.categoryName,id: subcat.categoryId});
          });
      
          this.categories.push({name: cat.categoryName,id: cat.categoryId})
        });
        this.getAppSettings();
      },
      error: (error: { error: { message: any; }; }) => this.alertService.alert(error.error.message, 'error'),
    });
  }

  update(type: number){

    let inputParams = {};

    if(type == 1){
      let pavingMenu = '';
      this.pavingCats.map(c =>  pavingMenu = (pavingMenu == '' ? pavingMenu : pavingMenu + ',') + c.id.toString() );
      inputParams = {pavingMenu : pavingMenu};
    }
    else if(type == 2){
      let categoryMenu = '';
       this.homeCats.map(c =>  categoryMenu = (categoryMenu == '' ? categoryMenu : categoryMenu + ',') + c.id.toString());
      inputParams = {categoryMenu : categoryMenu};
    }

    this.updateCompany(inputParams);
  }

  async updateCompany(params: any){
    await this.appSettingsService
    .updateCompanySettings(params)
    .subscribe({
      next: (response) => {
        this.alertService.alert("Category updated successfully!", 'success');
      },
      error: (error) => {
        this.alertService.alert(error.error.message, 'error');
      },
    });
  }


}
